module.exports = __webpack_public_path__ + "img/SZ.f7f4a7ba.svg";